import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Button, Accordion } from "react-bootstrap";
import CartContext from "./CartContext";

import {
  RestaurantPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  ReportsModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  DeliveryManagementModule,
  KdsModule,
  CaptainappModule,
  LeadsManagementModule,
  CouponsManagementModule,
  RecipeManagementModule,
  DigitalCatalogModule,
  GreetAppModule,
  QuoteManagementModule,
  SalesOrderModule,
  DemoButton,
} from "./CommonModules";

export class PosRestaurant extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handlePurchaseClick = () => {
    if (this.context.userData.loginStatus !== "active") {
      this.context.ShowUserLoginNew(true);
    }
    const product = this.context.prods.find(
      (f) => f.productType === this.context.ProductType.Restaurant_POS
    );
    if (product) {
      this.context.SetSelectedProduct(product);
    }
  };

  renderFeatureList = () => {
    const featureGroups = [
      {
        items: [
          "Front-Desk POS & KOT – Device Friendly",
          "Multi POS session support",
          "Captain App for table order management",
          "Kitchen Order Display System (KDS)",
          "Takeaway Display System",
          "Food Package Management System",
          "Table Orders Queue Display System",
          "Quick billing with paper/paperless invoices",
          "Chef App",
          "Delivery App",
          "Digital Catalog / Greeting App",
          "Manage dine-in, takeaway & home delivery orders",
          "Delivery charge and tax modules",
          "Search by SKU, shortcut codes, product category",
          "AI-based void recognition & fuzzy search",
          "Multiple payment options: Cash, Card, QR, COD, GPay, Payment Gateways",
          "Reports with UPI & Razorpay integration",
          "Accessible on phone, tablet, or PC",
          "Responsive design & 2FA security",
          "Barcode reading",
          "Weighing machine support",
          "Coupon and loyalty point programs",
          "In/out stock tracking",
          "Purchase Requests and Purchase Orders",
          "Inventory, Stock & Purchase Management",
          "Raw Materials & Supplier Management",
          "Orders & Packaging Management",
          "Delivery & CRM",
          "HRM, Payroll & Accounting",
          "Advanced Reports & Analytics",
        ],
      },
    ];

    return (
      <div className="bg-light p-0 rounded shadow-sm">
        <ul className="text-muted" style={{ lineHeight: "1.8em" }}>
          {featureGroups.map((group, index) => (
            <li key={index}>
              <ul>
                <Row>
                  {group.items.map((item, idx) => (
                    <Col md={6}>
                      <li key={idx}>{item}</li>
                    </Col>
                  ))}
                </Row>
              </ul>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        <section className="container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <Row className="mb-4">
              <Col>
                <div className="border-start border-5 border-primary ps-3">
                  <h6 className="text-primary text-uppercase mb-1">
                    Advanced Billing Solution
                  </h6>
                  <Row>
                    <Col md={8}>
                      <h2 className="display-6 fw-bold">
                        {/* Retail Point-Of-Sale (POS) */}
                        {this.context.prods.filter(
                          (f) =>
                            f.productType ===
                            this.context.ProductType.Restaurant_POS
                        )[0]?.name || ""}
                      </h2>
                    </Col>
                    <Col className="text-end">
                      <Button
                        variant="warning"
                        className=""
                        as={Link}
                        to="/Checkout"
                        onClick={this.handlePurchaseClick}
                      >
                        Try Free / Buy
                      </Button>
                      <DemoButton></DemoButton>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <h5>
              {this.context.prods.filter(
                (f) => f.productType === this.context.ProductType.Restaurant_POS
              )[0]?.description || ""}
            </h5>
            <div className="col-lg-12 mb-lg-5">
              <video
                controls
                height="400px"
                autoPlay
                muted
                loop
                width="100%"
                // className="rounded shadow"
                aria-label="POS software demo video"
              >
                <source
                  src={
                    this.context.GetEcSettingValueByName(
                      "StorageBlobImageUrl"
                    ) + "RestaurantPosVideo.mp4"
                  }
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <br />
            <br />
            <br />
            <div className="py-2">
              <Row>
                <Col md={8}>
                  <h4 className="display-6">Features and Benefits</h4>
                </Col>
                <Col>
                  <Button
                    variant="warning"
                    as={Link}
                    to="/Checkout"
                    onClick={this.handlePurchaseClick}
                  >
                    Try Free / Buy
                  </Button>
                </Col>
              </Row>
            </div>

            {this.renderFeatureList()}
          </div>
        </section>
        <DemoButton></DemoButton>
        <section className="container py-5">
          <h5 className="display-6 mb-4">
            Explore ERP Modules designed to streamline your restaurant business
          </h5>
          {this.renderModules()}
        </section>
        <DemoButton></DemoButton>
      </>
    );
  }

  renderModules = () => {
    const modules = [
      [<RestaurantPosModule />, <CaptainappModule />],
      [<InventoryModule />, <PurchasesModule />],
      [<OrdersManagementModule />, <KdsModule />],
      [<DeliveryManagementModule />, <RecipeManagementModule />],
      [<CrmModule />, <LeadsManagementModule />],
      [<QuoteManagementModule />, <SalesOrderModule />],
      [<DigitalCatalogModule />, <SalesOrderModule />],
      [<CouponsManagementModule />, <HrmModule />],
      [<AccountingModule />, <ReportsModule />],
    ];

    return modules.map((row, index) => (
      <Row key={index}>
        {row.map((Module, idx) => (
          <Col key={idx} className="bg-light p-3">
            {Module}
          </Col>
        ))}
      </Row>
    ));
  };
}
